import React, { useEffect, useState } from "react";

import { useNavigate } from "react-router-dom";
import { useSelector } from "react-redux";
import moment from "moment";
import PhoneInput from "react-phone-input-2";
import { ReactComponent as BackArrow } from "../../Icons/BorderBackArrow.svg";
import { ReactComponent as RefreshIcon } from "../../Icons/Refresh.svg";
import { ReactComponent as ContactDetailsIcon } from "../../Icons/ContactDetails.svg";
import { ReactComponent as BorderAlertCloseIcon } from "../../Icons/BorderAlertClose.svg";
import { ReactComponent as DatePickerIcon } from "../../Icons/Datepicker.svg";
import { ReactComponent as EditIcon } from "../../Icons/Edit.svg";
import { ReactComponent as BackArrowMobileIcon } from "../../Icons/BackArrowMobileIcon.svg";
import DeleteIcon from "@mui/icons-material/Delete";

import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";
import {
  DatePickerStyle,
  ErrorTypography,
  PrimaryTypography,
  SecondaryTypography,
  StyledSecondaryTypography,
  StyledTypography,
  TypoGraph,
  TypographyDefault,
  StyledSwitch,
  StyledPrimaryDefaultTypography,
  StyledSecondaryDefaultTypography,
} from "../../Theme";
import {
  Stack,
  Box,
  Button,
  Grid,
  MenuItem,
  Select,
  TextField,
  Typography,
  IconButton,
  Divider,
  TableContainer,
  Paper,
  Table,
  TableHead,
  TableRow,
  TableCell,
  TableBody,
  Tabs,
  Tab,
  Autocomplete,
  Modal,
  FormControlLabel,
  Radio,
  ToggleButton,
  ToggleButtonGroup,
  FormControl,
  InputLabel,
  RadioGroup,
} from "@mui/material";
import { DatePicker, LocalizationProvider } from "@mui/x-date-pickers";
import AlertModal, { PostLoaderModal } from "../../CommonComponents/modal";
import axiosInstance from "../../Redux/AxiosInstance";
import {
  userData,
  NameRegex,
  emailRegex,
  No_special_regex,
  getChip,
} from "../../Utils";
import { showToast } from "../../CommonComponents/Toaster";
import CustomTextEditor from "../../CommonComponents/CustomTextEditor";
import AddIcon from "@mui/icons-material/Add";
import parse from "html-react-parser";
import dayjs from "dayjs";
import { toast } from "react-toastify";
import ArrowDropUpIcon from "@mui/icons-material/ArrowDropUp";
import ArrowDropDownIcon from "@mui/icons-material/ArrowDropDown";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";

let deleteModalDatas = {
  label: "Delete Onboarding",
  descriptionOne: "Please confirm that you wish to delete onboarding staff. ",
  buttonOne: {
    variant: "outlined",
    color: "#0E5E84",
    backgroundColor: "#FFFFFF",
    text: "Cancel",
  },
  buttonTwo: {
    variant: "contained",
    color: "#FFFFFF",
    backgroundColor: "#B42318",
    text: "Delete Now",
  },
};

const reviewstyle = {
  minHeight: "61px",
  display: "flex",
  flexDirection: "column",
  justifyContent: "center",
  padding: "10px 0",
};

const days = ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"];

const CreateInvoice = () => {
  const { propertyId, userRole } = useSelector(
    (state) => state.PropertyDetails
  );
  console.log(propertyId);
  const { LanguageData } = useSelector((state) => state.Language);

  const { userDetails } = useSelector((state) => state.Login);
  const [repeatEvery, setRepeatEvery] = useState(1);

  const navigate = useNavigate();
  const [showDeleteModal, setshowDeleteModal] = useState(false);
  const [addblocks, setaddblocks] = useState({
    Personal_Details: true,
    WorkAccess_Details: false,
    Review_Information: false,
  });
  const [tabValue, settabValue] = useState(0);
  const [data, setData] = useState("");
  const [recurring, setRecurring] = useState(false);
  const [period, setPeriod] = useState("day");

  const [PersonalDetailsData, setPersonalDetailsData] = useState({
    recipients_type: "",
    lastname: "",
    middlename: "",
    dob: "",
    gender: "",
    nationality: "",
    inorpn: "",
    contact: "",
    phone: "",
    countrycode: "",
    email: "",
    address: "",
    country: "",
    city: "",
    postalcode: "",
  });
  console.log(PersonalDetailsData, "PersonalDetailsData");
  const [emergencyContactData, setemergencyContactData] = useState({
    firstname: "",
    lastname: "",
    // gender: '',
    // nationality: '',
    countrycode: "",
    contact: "",
    phone: "",
    email: "",
    relationship: "",
  });
  const [WorkAccessData, setWorkAccessData] = useState({
    employmenttype: "",
    department: "",
    jobrole: "",
    accessstartdate: "",
    accessenddate: "",
  });
  const [nationalityData, setnationalityData] = useState("");
  const [genderData, setgenderData] = useState([]);
  const [employeeTypeData, setemployeeTypeData] = useState([]);
  const [department, setDepartment] = useState([]);
  const [departmentIndex, setDepartmentIndex] = useState("");
  const [CountryList, setCountryList] = useState([]);
  const [CityList, setCityList] = useState([]);
  const [postLoader, SetPostLoader] = useState(false);
  const [description, setDescription] = useState("");
  const [checkdescription, setcheckdescription] = useState(0);
  const [type, setType] = useState("");
  const [datetimerangedata, setdatetimerangedata] = useState([null, null]);
  const [time, setTime] = useState({ start: "", end: "" });
  const [image, setImage] = useState([]);
  const [residents, setResidents] = useState([]);
  const [selectedResident, setSelectedResident] = useState({});
  console.log(selectedResident, "selectedResident");
  const [buildingData, setBuildingData] = useState([]);
  const [serviceList, setServiceList] = useState([]);
  const [typedValue, setTypedValue] = useState("");
  const [handlingCharge, setHandlingCharge] = useState("");
  const [subTotal, setSubTotal] = useState("");
  const [total, setTotal] = useState("");
  console.log(total, "total");
  const [gstAmount, setGstAmount] = useState("");
  const [selectedbuilding, setSelectedBuilding] = useState({});
  const [open, setOpen] = useState(false);

  const [groups, setGroups] = useState([]);
  const [selectedGroup, setSelectedGroup] = useState({});
  console.log(selectedGroup, "selectedGroup");
  const [selectedEndOption, setSelectedEndOption] = useState("never");
  const [endDate, setEndDate] = useState("");
  const [afterOccurrences, setAfterOccurrences] = useState("");
  const today = dayjs().day(); // 0=Sunday, 6=Saturday
  const [selectedDays, setSelectedDays] = useState([today]);
  const todays = dayjs();

  // Default values
  const [monthOption, setMonthOption] = useState("date"); // "date" or "weekday"
  const [dayOfMonth, setDayOfMonth] = useState(todays.date()); // e.g. 22
  const [weekday, setWeekday] = useState(todays.day()); // 0=Sun … 6=Sat
  const [weekNumber, setWeekNumber] = useState(Math.ceil(todays.date() / 7)); // 1st, 2nd, 3rd, 4th, 5th
  const [endType, setEndType] = useState("never"); // "never" | "on_date" | "after"
  const [invoiceError, setInvoiceError] = useState("");
  const [yearMonth, setYearMonth] = useState(1); // default January
  const [yearDay, setYearDay] = useState(1); // default 1st day

  const weekdays = [
    "Sunday",
    "Monday",
    "Tuesday",
    "Wednesday",
    "Thursday",
    "Friday",
    "Saturday",
  ];
  const weekNumbers = ["First", "Second", "Third", "Fourth", "Last"];

  const handleChange = (event, newDays) => {
    // Prevent empty selection → keep at least one day
    if (newDays.length === 0) return;
    setSelectedDays(newDays);
  };

  const handlePeriodChange = (e) => {
    setPeriod(e.target.value);
  };

  const options = ["day", "week", "month", "year"].map((opt) => {
    return repeatEvery > 1 ? `${opt}s` : opt;
  });

  const invoiceData = {
    item_master_id: "",
    item_name: "",
    unit_id: "",
    description: "",
    unit_name: "",
    quantity: "",
    price: "",
    total_price: "",
    opt: null,
  };

  const [invoiceItems, setInvoiceItems] = useState([invoiceData]);

  const addInvoiceItem = () => {
    setInvoiceItems([...invoiceItems, invoiceData]);
  };

  const removeInvoiceItem = (index) => {
    const updatedItems = invoiceItems.filter((item, i) => i !== index);
    setInvoiceItems(updatedItems);
  };

  const validateInvoiceItems = () => {
    let isValid = true;

    if (invoiceItems.length === 0) {
      setInvoiceError("At least one invoice item is required");
      isValid = false;
    } else {
      // Check if any row has missing data
      const hasMissingData = invoiceItems.some(
        (item) => !item.opt || !item.unit_name || !item.quantity || !item.price
      );

      if (hasMissingData) {
        setInvoiceError("Please fill all invoice item details");
        isValid = false;
      }
    }
    return isValid;
  };

  console.log(invoiceItems);

  const updateInvoiceItem = (index, field, value) => {
    setInvoiceItems((prev) =>
      prev.map((item, i) =>
        i === index
          ? {
              ...item,
              [field]: value,
              total_price:
                field === "quantity" || field === "price"
                  ? (
                      (field === "quantity" ? value : item.quantity || 0) *
                      (field === "price" ? value : item.price || 0)
                    ).toFixed(2)
                  : item.total_price,
            }
          : item
      )
    );
  };

  // const updateInvoiceItem = (index, field, value) => {
  //   const updatedItems = invoiceItems.map((item, i) =>
  //     i === index ? { ...item, [field]: value } : item
  //   );
  //   setInvoiceItems(updatedItems);
  // };

  const updateInvoiceItem1 = (index, field, value) => {
    const updatedItems = invoiceItems.map((item, i) =>
      i === index
        ? {
            ...item,
            [field]: value,
            item_name: value?.item_name || "",
            unit_name: value?.unit_name || "",
            quantity: value?.quantity || "",
            price: value?.price || "",
            item_master_id: value?.id || "",
            unit_id: value?.unit_id || "",
            total_price: ((value?.quantity || 0) * (value?.price || 0)).toFixed(
              2
            ),
          }
        : item
    );
    setInvoiceItems(updatedItems);
    setTypedValue("");
  };

  const date = (val) => {
    const formattedDob = moment(val).format("DD MMM YYYY ").toString();
    return formattedDob;
  };

  useEffect(() => {
    const calculatedSubTotal = invoiceItems
      .reduce((acc, item) => acc + item.price * item.quantity, 0)
      .toFixed(2);
    setSubTotal(calculatedSubTotal);

    const handlingCharged = parseFloat(handlingCharge || 0).toFixed(2);
    const gstAmount = (parseFloat(calculatedSubTotal) * 0.09).toFixed(2);
    setGstAmount(gstAmount);

    const totalAmount =
      parseFloat(calculatedSubTotal) +
      parseFloat(handlingCharged) +
      parseFloat(gstAmount);

    setTotal(totalAmount.toFixed(2));
  }, [invoiceItems, handlingCharge]);

  const [onboardedby, setonboardedby] = useState({
    name: userDetails?.name,
    email: userDetails?.email,
    department: userData("department_details")?.department_name,
    jobrole:
      userRole == 2
        ? userDetails?.user_role_details?.role_name
        : userData("role_details")?.title,
  });
  const [errtext, seterrtext] = useState({
    PersonalDetailsData: {
      recipients_type: "",
      group: "",
      resident: "",
      invoice_date: "",
      due_date: "",
      description: "",
    },
    emergencyContactData: {},
    WorkAccessData: {},
  });
  console.log(errtext, "errtext");

  //add api

  const increaseRepeatEvery = () => {
    setRepeatEvery(repeatEvery + 1);
  };

  const decreaseRepeatEvery = () => {
    if (repeatEvery > 1) {
      setRepeatEvery(repeatEvery - 1);
    }
  };

  const getAllFaultReport = async () => {
    await axiosInstance
      .get(
        // `${process.env.REACT_APP_API_URL}fault_report/property/${propertyId}?page=${currentPage}&record_count=${rowsPerPage}&status_id=${data}&sort=${SelectedsortData}&search=${searchData}`
        `${process.env.REACT_APP_API_URL}item-master/${propertyId}?search=${typedValue}`
      )
      .then((data) => {
        console.log(data);
        setServiceList(data?.data?.data?.invoices || []);
        // setPaginationData(data?.data?.data?.pagination_details);
        // setTableloading(false);
      })
      .catch((err) => {
        console.log(err);
        console.log(err?.response?.data?.error);
        if (err?.response?.data?.error == "No data found") {
          // setFaultList([]);
        }
        // setTableloading(false);
      });
  };

  useEffect(() => {
    getAllFaultReport();
  }, []);

  useEffect(() => {
    if (typedValue.length > 0) {
      getAllFaultReport();
    }
  }, [typedValue]);

  console.log(typedValue);

  useEffect(() => {
    axiosInstance
      .get(`${process.env.REACT_APP_API_URL}getDropDownDatas?type=country`)
      .then((res) => {
        setCountryList(res.data.data?.drop_down);
      })
      .catch((err) => {
        console.error(err);
      });
  }, []);

  useEffect(() => {
    axiosInstance
      .get(
        `${process.env.REACT_APP_API_URL}onboard/property/${propertyId}/resident_onboard?search=${data}`
      )
      .then((res) => {
        console.log(res);
        setResidents(res?.data.data?.resident_onboard);
      })
      .catch((err) => {
        console.error(err);
      });
  }, [data]);

  useEffect(() => {
    axiosInstance
      .get(
        `${process.env.REACT_APP_API_URL}invoice-recurring/${propertyId}?search=${data}`
      )
      .then((res) => {
        console.log(res);
        setGroups(res?.data?.data?.pagination_data || []);
      })
      .catch((err) => {
        console.error(err);
      });
  }, []);

  useEffect(() => {
    const getnationality = async () => {
      try {
        const response = await axiosInstance.get(
          `${process.env.REACT_APP_API_URL}getDropDownDatas?type=nationality`
        );
        const nationalityData = response.data.data.drop_down;
        var nationalitymenuItems = [];
        for (const key in nationalityData) {
          nationalitymenuItems.push(
            <MenuItem key={key} value={key}>
              {nationalityData[key]}
            </MenuItem>
          );
        }
        setnationalityData(nationalitymenuItems);
      } catch (error) {
        console.log(error.message);
      }
    };
    getnationality();

    const getGenderData = async () => {
      try {
        const response = await axiosInstance.get(
          `${process.env.REACT_APP_API_URL}getDropDownDatas?type=gender`
        );
        const genderData = response.data.data.drop_down;
        setgenderData(genderData);
      } catch (error) {
        console.log(error.message);
      }
    };
    getGenderData();
    const getResidentTypeData = async () => {
      try {
        const response = await axiosInstance.get(
          `${process.env.REACT_APP_API_URL}getDropDownDatas?type=residency_type_employee`
        );
        const employeeTypeData = response.data.data.drop_down;
        setemployeeTypeData(employeeTypeData);
      } catch (error) {
        console.log(error.message);
      }
    };
    getResidentTypeData();

    const getDepartment = async () => {
      try {
        const response = await axiosInstance.get(
          `${process.env.REACT_APP_API_URL}property/${propertyId}/role`
        );
        const departmentdata = response.data.data.property_role;
        setDepartment(departmentdata);
      } catch (error) {
        console.log(error.message);
      }
    };
    getDepartment();

    const getBuildingData = async () => {
      try {
        const response = await axiosInstance.get(
          `${process.env.REACT_APP_API_URL}property/${propertyId}/building`
        );
        const BuildingData = response.data.data.property_buildings;
        setBuildingData(BuildingData);
      } catch (error) {
        console.log(error.message);
      }
    };
    getBuildingData();
  }, []);

  const DepartmentDropDown = (index) => {
    setDepartmentIndex(index);
    setWorkAccessData((prev) => {
      return { ...prev, jobrole: "" };
    });
  };

  const handleTabValue = (e, value) => {
    settabValue(value);
  };

  const CustomTabPanel = ({ value, index, children }) => {
    return <>{index == value && <Box>{children}</Box>}</>;
  };

  const validatePersonalDetails = () => {
    let errors = {
      recipients_type: "",
      group: "",
      resident: "",
      invoice_date: "",
      due_date: "",
      description: "",
    };

    if (!PersonalDetailsData.recipients_type) {
      errors.recipients_type = "Recipients type is required";
    }

    if (PersonalDetailsData.recipients_type === 2 && !selectedGroup?.id) {
      errors.group = "Group selection is required";
    }

    if (
      PersonalDetailsData.recipients_type === 1 &&
      !selectedResident?.user_id
    ) {
      errors.resident = "Resident selection is required";
    }

    if (!PersonalDetailsData.invoice_date) {
      errors.invoice_date = "Invoice date is required";
    }

    if (!PersonalDetailsData.due_date) {
      errors.due_date = "Due date is required";
    }

    seterrtext((prev) => ({
      ...prev,
      PersonalDetailsData: errors,
    }));

    return Object.values(errors).every((val) => val === "");
  };

  const isValid = (curval) => {
    let isError = false;
    // Personaldetails
    if (curval === "Personal Details") {
      for (const key in PersonalDetailsData) {
        if (key === "email" && PersonalDetailsData[key] !== "") {
          if (!emailRegex.test(PersonalDetailsData[key])) {
            seterrtext((prev) => {
              return {
                ...prev,
                PersonalDetailsData: {
                  ...prev.PersonalDetailsData,
                  [key]: "Error! Invalid Email Format",
                },
              };
            });
            isError = true;
          }
        } else if (key === "dob" && PersonalDetailsData[key].$d > new Date()) {
          seterrtext((prev) => {
            return {
              ...prev,
              PersonalDetailsData: {
                ...prev.PersonalDetailsData,
                [key]: "Error! Date of Birth should before today",
              },
            };
          });
          isError = true;
        }
        // else if (key === 'phone' && PersonalDetailsData[key].length < 10) {
        //     seterrtext((prev) => {
        //         return ({
        //             ...prev, PersonalDetailsData: {
        //                 ...prev.PersonalDetailsData,
        //                 [key]: 'Error! Contact number must be above 10 number ',
        //             }
        //         })
        //     })
        //     isError = true
        // }
        else if (key === "phone") {
          if (
            PersonalDetailsData[key] === "" ||
            PersonalDetailsData[key] === null ||
            PersonalDetailsData[key].length < 6
          ) {
            seterrtext((prev) => {
              return {
                ...prev,
                PersonalDetailsData: {
                  ...prev.PersonalDetailsData,
                  [key]:
                    PersonalDetailsData[key] === "" ||
                    PersonalDetailsData[key] === null
                      ? "Error! No Inputs detected"
                      : "Error! Phone should not below 6 numbers ",
                },
              };
            });
            isError = true;
          }
        } else if (key === "postalcode") {
          if (
            PersonalDetailsData[key] === "" ||
            PersonalDetailsData[key] === null
          ) {
            seterrtext((prev) => {
              return {
                ...prev,
                PersonalDetailsData: {
                  ...prev.PersonalDetailsData,
                  [key]: "Error! No Inputs detected",
                },
              };
            });
            isError = true;
          } else if (PersonalDetailsData[key].length < 5) {
            seterrtext((prev) => {
              return {
                ...prev,
                PersonalDetailsData: {
                  ...prev.PersonalDetailsData,
                  [key]: "Error! Postal Code must be above 5 numbers ",
                },
              };
            });
            isError = true;
          }
        } else if (
          (PersonalDetailsData[key] === "" ||
            PersonalDetailsData[key] === null) &&
          key !== "middlename"
        ) {
          seterrtext((prev) => {
            return {
              ...prev,
              PersonalDetailsData: {
                ...prev.PersonalDetailsData,
                [key]: "Error! No Inputs detected",
              },
            };
          });
          isError = true;
        }
      }
      //emergencycontact
      for (const key in emergencyContactData) {
        if (key === "email" && emergencyContactData[key] !== "") {
          if (!emailRegex.test(emergencyContactData[key])) {
            seterrtext((prev) => {
              return {
                ...prev,
                emergencyContactData: {
                  ...prev.emergencyContactData,
                  [key]: "Error! Invalid Email Format",
                },
              };
            });
            isError = true;
          }
        }
        // else if (key === 'phone' && emergencyContactData[key].length < 10) {
        //     seterrtext((prev) => {
        //         return ({
        //             ...prev, emergencyContactData: {
        //                 ...prev.emergencyContactData,
        //                 [key]: 'Error! Contact number must be above 10 number ',
        //             }
        //         })
        //     })
        //     isError = true
        // }
        else if (key === "phone") {
          if (
            emergencyContactData[key] === "" ||
            emergencyContactData[key] === null ||
            emergencyContactData[key].length < 6
          ) {
            seterrtext((prev) => {
              return {
                ...prev,
                emergencyContactData: {
                  ...prev.emergencyContactData,
                  [key]:
                    emergencyContactData[key] === "" ||
                    emergencyContactData[key] === null
                      ? "Error! No Inputs detected"
                      : "Error! Phone should not below 6 numbers ",
                },
              };
            });
            isError = true;
          }
        } else if (emergencyContactData[key] === "" && key !== "lastname") {
          seterrtext((prev) => {
            return {
              ...prev,
              emergencyContactData: {
                ...prev.emergencyContactData,
                [key]: "Error! No Inputs detected",
              },
            };
          });
          isError = true;
        }
      }
    } else if (curval === "Work & Access Details") {
      for (const key in WorkAccessData) {
        if (key === "accessenddate" && WorkAccessData.employmenttype != "2") {
          if (WorkAccessData[key] === "" || WorkAccessData[key] === null) {
            seterrtext((prev) => {
              return {
                ...prev,
                WorkAccessData: {
                  ...prev.WorkAccessData,
                  [key]: "Error! No Inputs detected",
                },
              };
            });
            isError = true;
          } else if (
            WorkAccessData.accessstartdate.$d >= WorkAccessData.accessenddate.$d
          ) {
            seterrtext((prev) => {
              return {
                ...prev,
                WorkAccessData: {
                  ...prev.WorkAccessData,
                  [key]: "Error! End date should be greater than start date",
                },
              };
            });
            isError = true;
          }
        } else if (
          (WorkAccessData[key] === "" || WorkAccessData[key] === null) &&
          key !== "accessenddate"
        ) {
          seterrtext((prev) => {
            return {
              ...prev,
              WorkAccessData: {
                ...prev.WorkAccessData,
                [key]: "Error! No Inputs detected",
              },
            };
          });
          isError = true;
        }
      }
    }
    return isError;
  };
  //personalDetails
  const Continue = (nxtval, curval) => {
    if (nxtval === "Resident & Invoice Details") {
      setaddblocks({
        Personal_Details: true,
        WorkAccess_Details: false,
        Review_Information: false,
      });
    } else if (nxtval === "Invoice Items & Payment Details") {
      setaddblocks({
        Personal_Details: false,
        WorkAccess_Details: true,
        Review_Information: false,
      });
    } else if (nxtval === "Review & Send") {
      setaddblocks({
        Personal_Details: false,
        WorkAccess_Details: false,
        Review_Information: true,
      });
    }
  };

  const DropdownEmpty = (val) => {
    if (val === "building") {
      setWorkAccessData((prev) => {
        return {
          ...prev,
          level: "",
          unit: "",
        };
      });
    } else if (val === "level") {
      setWorkAccessData((prev) => {
        return {
          ...prev,
          unit: "",
        };
      });
    }
  };

  const handlePersonalDetails = (e, name) => {
    if (name) {
      setPersonalDetailsData((prev) => {
        return {
          ...prev,
          [name]: e,
        };
      });
      seterrtext((prev) => {
        return {
          ...prev,
          PersonalDetailsData: {
            ...prev.PersonalDetailsData,
            [name]: "",
          },
        };
      });
    } else {
      const { name, value } = e.target;
      if (name === "country" && value) {
        setCityList([]);
        const selectedCountry = value;
        const selectedCountryObject = CountryList.find(
          (city) => city.country === selectedCountry
        );
        setCityList(selectedCountryObject?.city);
        setPersonalDetailsData((prevData) => ({
          ...prevData,
          city: "",
        }));
      }
      setPersonalDetailsData((prev) => {
        return {
          ...prev,
          [name]: value,
        };
      });
      seterrtext((prev) => {
        return {
          ...prev,
          PersonalDetailsData: {
            ...prev.PersonalDetailsData,
            [name]: "",
          },
        };
      });
    }
  };
  const handleMobileInput = (
    value,
    country,
    functionName,
    state,
    statename
  ) => {
    functionName({
      ...state,
      contact: value,
      countrycode: `+ ${country.dialCode}`,
      phone: value.slice(country.dialCode.length),
    });
    seterrtext((prev) => {
      return {
        ...prev,
        [statename]: {
          ...prev[statename],
          countrycode: "",
          phone: "",
        },
      };
    });
  };

  const handleEmergencyContact = (e) => {
    const { name, value } = e.target;
    setemergencyContactData((prev) => {
      return {
        ...prev,
        [name]: value,
      };
    });
    seterrtext((prev) => {
      return {
        ...prev,
        emergencyContactData: {
          ...prev.emergencyContactData,
          [name]: "",
        },
      };
    });
  };

  const handleWorkAccess = (e, name) => {
    if (name) {
      setWorkAccessData((prev) => {
        return {
          ...prev,
          [name]: e,
        };
      });
      seterrtext((prev) => {
        return {
          ...prev,
          WorkAccessData: {
            ...prev.WorkAccessData,
            [name]: "",
          },
        };
      });
    } else {
      const { name, value } = e.target;
      setWorkAccessData((prev) => {
        return {
          ...prev,
          [name]: value,
        };
      });
      seterrtext((prev) => {
        return {
          ...prev,
          WorkAccessData: {
            ...prev.WorkAccessData,
            [name]: "",
          },
        };
      });
      if (name === "employmenttype" && value == "2") {
        setWorkAccessData((prev) => {
          return {
            ...prev,
            accessenddate: "",
          };
        });
        seterrtext((prev) => {
          return {
            ...prev,
            WorkAccessData: {
              ...prev.WorkAccessData,
              accessenddate: "",
            },
          };
        });
      }
    }
  };

  const blocks = [
    { status: addblocks.Personal_Details, tle: "Resident & Invoice Details" },
    {
      status: addblocks.WorkAccess_Details,
      tle: "Invoice Items & Payment Details",
    },
    { status: addblocks.Review_Information, tle: "Review & Send" },
  ];

  console.log(repeatEvery);
  console.log(period);
  console.log(monthOption); // "date" or "weekday"
  console.log(dayOfMonth); // e.g. 22
  console.log(weekday); // 0=Sun … 6=Sat
  console.log(weekNumber); // 1st, 2nd, 3rd, 4th, 5th
  console.log(selectedDays); // array of selected days (0=Sun … 6=Sat)
  console.log(endType); // "never" | "on_date" | "after"
  console.log(endDate);
  console.log(afterOccurrences);

  const addInvoice = async () => {
    if (PersonalDetailsData.recipients_type == 1) {
      try {
        SetPostLoader(true);
        const response = await axiosInstance.post(
          `${process.env.REACT_APP_API_URL}invoice/${propertyId}`,
          {
            recipients_type: PersonalDetailsData.recipients_type,
            resident_id: selectedResident?.user_id,
            property_building_id: selectedResident.building_id,
            building_level_id: selectedResident.level_id,
            building_unit_id: selectedResident.unit_id,
            invoice_date: moment(PersonalDetailsData.invoice_date).format(
              "YYYY-MM-DD"
            ),
            due_date: moment(PersonalDetailsData.due_date).format("YYYY-MM-DD"),
            terms_and_conditions: description,
            mark_as_recurring: recurring,
            sub_total: subTotal,
            handling_amount: handlingCharge || 0,
            gst: gstAmount,
            total_amount: total,
            items: invoiceItems,
            repeatEvery,
            period,
            monthOption,
            dayOfMonth,
            weekday,
            weekNumber,
            selectedDays,
            endType,
            endDate,
            afterOccurrences,
            yearMonth,
            yearDay
          }
        );
        if (response.status === 201) {
          SetPostLoader(false);
          toast.success("Invoice Created Successfully");
          navigate("/invoice-list");
        } else {
          SetPostLoader(false);
          toast.error("Something went wrong! Please try again.");
        }
      } catch (error) {
        SetPostLoader(false);
        toast.error("Something went wrong! Please try again.");
        console.error(error);
      }
    } else {
      try {
        SetPostLoader(true);
        const response = await axiosInstance.post(
          `${process.env.REACT_APP_API_URL}invoice/${propertyId}`,
          {
            recipients_type: PersonalDetailsData.recipients_type,
            invoice_recurring_list_id: selectedGroup?.id,
            invoice_date: moment(PersonalDetailsData.invoice_date).format(
              "YYYY-MM-DD"
            ),
            due_date: moment(PersonalDetailsData.due_date).format("YYYY-MM-DD"),
            terms_and_conditions: description,
            mark_as_recurring: recurring,
            sub_total: subTotal,
            handling_amount: handlingCharge || 0,
            gst: gstAmount,
            total_amount: total,
            items: invoiceItems,
            period,
            monthOption,
            dayOfMonth,
            weekday,
            weekNumber,
            selectedDays,
            endType,
            endDate,
            afterOccurrences,
             yearMonth,
            yearDay
          }
        );
        if (response.status === 201) {
          SetPostLoader(false);
          toast.success("Invoice Created Successfully");
          navigate("/invoice-list");
        } else {
          toast.error("Something went wrong! Please try again.");
          SetPostLoader(false);
        }
      } catch (error) {
        SetPostLoader(false);

        toast.error("Something went wrong! Please try again.");
        console.error(error);
      }
    }
  };

  console.log(selectedGroup);

  const PersonalDetails = () => {
    return (
      <>
        <Box
          mt={3}
          component="div"
          boxShadow="0 0 3px 0 rgba(0 ,0 ,0 ,0.1)"
          borderRadius="8px"
        >
          <Stack
            direction="row"
            alignItems="center"
            gap="10px"
            px="16px"
            sx={{
              height: "66px",
              backgroundColor: "#FCFCFD",
              border: "1px solid #E5E7EB",
              borderRadius: "8px 8px 0 0 ",
            }}
          >
            <ContactDetailsIcon />
            <SecondaryTypography>Invoice Information</SecondaryTypography>
          </Stack>
          <Grid
            container
            xs={12}
            gap="2.8%"
            sx={{
              backgroundColor: "white",
              padding: "30px 16px 30px 16px",
              border: "1px solid #E5E7EB",
              borderRadius: "0 0 8px 8px  ",
            }}
          >
            <Grid xs={12} sm={12}>
              <StyledTypography>Choose Recipients*</StyledTypography>
              <Select
                name="recipients_type"
                value={PersonalDetailsData.recipients_type}
                onChange={(e) => handlePersonalDetails(e)}
                sx={{
                  "& .MuiInputBase-root": {
                    color: errtext.PersonalDetailsData.recipients_type
                      ? "#912018"
                      : "#111927",
                  },
                  "& .MuiOutlinedInput-notchedOutline": {
                    border: "none !important",
                  },
                  backgroundColor: errtext.PersonalDetailsData.recipients_type
                    ? "#FEE4E2"
                    : " #F9FAFB",
                  width: "100%",
                }}
                IconComponent={KeyboardArrowDownIcon}
              >
                <MenuItem value={1}>Single Resident</MenuItem>
                <MenuItem value={2}>Multiple Residents</MenuItem>
              </Select>
              <ErrorTypography>
                {errtext.PersonalDetailsData.recipients_type}
              </ErrorTypography>
            </Grid>

            {PersonalDetailsData.recipients_type === 2 && (
              <Grid xs={12} sm={12} sx={{ mt: 2 }}>
                <StyledTypography>Select List*</StyledTypography>
                <Autocomplete
                  options={groups}
                  getOptionLabel={(option) => option?.title || ""}
                  renderInput={(params) => (
                    <TextField
                      {...params}
                      placeholder="Search Group"
                      variant="outlined"
                    />
                  )}
                  onChange={(event, value) => {
                    setSelectedGroup(value);
                    seterrtext((prev) => ({
                      ...prev,
                      PersonalDetailsData: {
                        ...prev.PersonalDetailsData,
                        group: "",
                      },
                    }));
                  }}
                  value={selectedGroup || ""}
                  // inputValue={data}
                  // onInputChange={(event, newInputValue) => setData(newInputValue)}
                  sx={{ width: "100%" }}
                />
                <ErrorTypography>
                  {errtext.PersonalDetailsData.group}
                </ErrorTypography>
              </Grid>
            )}

            {PersonalDetailsData.recipients_type === 1 && (
              <>
                <Grid xs={12} sm={12} mt={2}>
                  <StyledTypography>Select Resident*</StyledTypography>
                  <Autocomplete
                    options={residents}
                    getOptionLabel={(option) =>
                      option?.user_details
                        ? `${option.user_details.name || ""} | ${
                            option.user_details.email || ""
                          } | ${
                            option.user_details.personal_details?.phone || ""
                          }`
                        : ""
                    }
                    renderInput={(params) => (
                      <TextField
                        {...params}
                        placeholder="Search Resident"
                        variant="outlined"
                      />
                    )}
                    onChange={(event, value) => {
                      // clear error if user selects something
                      seterrtext((prev) => ({
                        ...prev,
                        PersonalDetailsData: {
                          ...prev.PersonalDetailsData,
                          resident: "",
                        },
                      }));
                      setSelectedResident(value);
                    }}
                    value={selectedResident || ""}
                    inputValue={data}
                    onInputChange={(event, newInputValue) => {
                      setData(newInputValue);
                      // also clear error when user starts typing
                      if (errtext.PersonalDetailsData.resident) {
                        seterrtext((prev) => ({
                          ...prev,
                          PersonalDetailsData: {
                            ...prev.PersonalDetailsData,
                            resident: "",
                          },
                        }));
                      }
                    }}
                    sx={{ width: "100%" }}
                  />

                  <ErrorTypography>
                    {errtext.PersonalDetailsData.resident}
                  </ErrorTypography>
                </Grid>
              </>
            )}

            <Grid xs={12} sm={5.8} mt={2}>
              <StyledTypography>Invoice Date*</StyledTypography>
              <DatePicker
                disableFuture
                format="DD/MM/YYYY"
                slots={{ openPickerIcon: () => <DatePickerIcon /> }}
                name="invoice_date"
                value={PersonalDetailsData.invoice_date || null}
                onChange={(value) =>
                  handlePersonalDetails(value, "invoice_date")
                }
                sx={{
                  ...DatePickerStyle,
                  backgroundColor: Boolean(
                    errtext.PersonalDetailsData.invoice_date
                  )
                    ? "#FEE4E2"
                    : "",

                  "& .MuiInputBase-root": {
                    color: errtext.PersonalDetailsData.invoice_date
                      ? "#912018"
                      : "#111927",
                  },
                }}
              />
              <ErrorTypography>
                {errtext.PersonalDetailsData.invoice_date}
              </ErrorTypography>
            </Grid>
            <Grid xs={12} sm={5.8} mt={2}>
              <StyledTypography>Due Date*</StyledTypography>
              <DatePicker
                format="DD/MM/YYYY"
                slots={{ openPickerIcon: () => <DatePickerIcon /> }}
                name="due_date"
                value={PersonalDetailsData.due_date || null}
                onChange={(value) => handlePersonalDetails(value, "due_date")}
                sx={{
                  ...DatePickerStyle,
                  backgroundColor: Boolean(errtext.PersonalDetailsData.due_date)
                    ? "#FEE4E2"
                    : "",

                  "& .MuiInputBase-root": {
                    color: errtext.PersonalDetailsData.due_date
                      ? "#912018"
                      : "#111927",
                  },
                }}
              />
              <ErrorTypography>
                {errtext.PersonalDetailsData.due_date}
              </ErrorTypography>
            </Grid>
          </Grid>
        </Box>
        <Box
          mt={3}
          component="div"
          boxShadow="0 0 3px 0 rgba(0 ,0 ,0 ,0.1)"
          borderRadius="8px"
        >
          <Stack
            direction="row"
            alignItems="center"
            gap="10px"
            px="16px"
            sx={{
              height: "66px",
              backgroundColor: "#FCFCFD",
              border: "1px solid #E5E7EB",
              borderRadius: "8px 8px 0 0 ",
            }}
          >
            <ContactDetailsIcon />
            <SecondaryTypography>Terms & Conditions</SecondaryTypography>
          </Stack>
          <Grid
            container
            xs={12}
            gap="2.8%"
            sx={{ backgroundColor: "white", padding: "30px 16px 30px 16px" }}
          >
            <Grid xs={12}>
              <Box sx={{ position: "relative" }}>
                <CustomTextEditor
                  textEditorvalue={description}
                  settextEditorvalue={setDescription}
                  setcheckdescription={setcheckdescription}
                  textEditorErr={errtext?.description}
                />
              </Box>
            </Grid>
          </Grid>
        </Box>
        <Box
          mt={3}
          bgcolor="#FFFFFF"
          sx={{
            border: "1px solid  #E5E7EB",
            borderTop: " 1px solid #F3F4F6",
            boxShadow: "0 0 3px 0 rgba(0 ,0 ,0 ,0.1)",
            borderRadius: "8px 8px 8px 8px",
          }}
        >
          <Stack
            direction="row"
            py={2}
            px={2}
            justifyContent="end"
            alignItems="center"
            height="60px"
          >
            {/* <Stack direction='row'>
                            <RefreshIcon style={{ marginRight: '5px' }} />
                            <StyledSecondaryTypography>Last Updated at  {moment(new Date()).format('HH:mm A')}</StyledSecondaryTypography>
                        </Stack> */}
            <Stack direction="column" justifyContent="end" alignItems="end">
              <Button
                type="button"
                onClick={() => {
                  if (validatePersonalDetails()) {
                    Continue(
                      "Invoice Items & Payment Details",
                      "Resident & Invoice Details"
                    );
                  }
                }}
                variant="Standard"
              >
                Continue
              </Button>
            </Stack>
          </Stack>
        </Box>
      </>
    );
  };
  const WorkAccessDetails = () => {
    return (
      <>
        <Box
          mt={3}
          component="div"
          boxShadow="0 0 3px 0 rgba(0 ,0 ,0 ,0.1)"
          sx={{ borderRadius: "8px" }}
        >
          <Stack
            direction="row"
            alignItems="center"
            gap="10px"
            px="16px"
            sx={{
              height: "66px",
              backgroundColor: "#FCFCFD",
              border: "1px solid #E5E7EB",
              borderRadius: "8px 8px 0px 0px",
            }}
          >
            <ContactDetailsIcon />
            <SecondaryTypography>Invoice Items</SecondaryTypography>
          </Stack>
          <TableContainer
            sx={{ backgroundColor: "#FFF", borderRadius: "0px 0px 8px 8px" }}
          >
            <Table>
              <TableHead>
                <TableRow sx={{ backgroundColor: "#F6F6F6" }}>
                  <TableCell sx={{ padding: "8px" }}>Item Name</TableCell>
                  <TableCell sx={{ padding: "8px" }}>Unit</TableCell>
                  <TableCell sx={{ padding: "8px" }}>Qty</TableCell>
                  <TableCell sx={{ padding: "8px" }}>Item Price</TableCell>
                  <TableCell sx={{ padding: "8px" }}>Total</TableCell>
                  <TableCell sx={{ padding: "8px" }}>Actions</TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {invoiceItems.map((item, index) => (
                  <>
                    <TableRow key={index}>
                      <TableCell sx={{ width: "50%", borderBottom: "0px" }}>
                        {" "}
                        <Autocomplete
                          options={serviceList}
                          getOptionLabel={(option) =>
                            `${option?.item_name || ""}`
                          }
                          renderInput={(params) => (
                            <TextField
                              {...params}
                              placeholder="Search Service"
                              variant="outlined"
                            />
                          )}
                          onChange={(event, value) => {
                            updateInvoiceItem1(index, "opt", value);
                            setInvoiceError("");
                          }}
                          value={item.opt}
                          onInputChange={(event, newInputValue) => {
                            setTypedValue(newInputValue);
                            setInvoiceError("");
                          }}
                          sx={{ width: 400 }}
                        />
                      </TableCell>
                      <TableCell sx={{ borderBottom: "0px" }}>
                        <TextField
                          sx={{
                            "& .MuiInputBase-root": {
                              color: errtext?.title ? "#912018" : "#111927",
                            },
                            backgroundColor: errtext?.title
                              ? "#FEE4E2"
                              : " #F9FAFB",
                          }}
                          value={item.unit_name}
                          name="unit_name"
                          placeholder="Unit"
                          onChange={(e) => {
                            updateInvoiceItem(
                              index,
                              "unit_name",
                              e.target.value
                            );
                            setInvoiceError("");
                          }}
                          inputProps={{ maxLength: 50 }}
                          InputProps={{
                            disableUnderline: true,
                          }}
                          fullWidth
                        />
                      </TableCell>
                      <TableCell sx={{ borderBottom: "0px" }}>
                        <TextField
                          sx={{
                            "& .MuiInputBase-root": {
                              color: errtext?.title ? "#912018" : "#111927",
                            },
                            backgroundColor: errtext?.title
                              ? "#FEE4E2"
                              : " #F9FAFB",
                          }}
                          name="Qty"
                          value={item.quantity}
                          placeholder="Qty"
                          onChange={(e) => {
                            updateInvoiceItem(
                              index,
                              "quantity",
                              e.target.value
                            );
                            setInvoiceError("");
                          }}
                          inputProps={{ maxLength: 50 }}
                          InputProps={{
                            disableUnderline: true,
                          }}
                          fullWidth
                        />
                      </TableCell>
                      <TableCell sx={{ borderBottom: "0px" }}>
                        <TextField
                          sx={{
                            "& .MuiInputBase-root": {
                              color: errtext?.title ? "#912018" : "#111927",
                            },
                            backgroundColor: errtext?.title
                              ? "#FEE4E2"
                              : " #F9FAFB",
                          }}
                          name="price"
                          placeholder="Price"
                          value={item.price}
                          onChange={(e) => {
                            updateInvoiceItem(index, "price", e.target.value);
                            setInvoiceError("");
                          }}
                          inputProps={{ maxLength: 50 }}
                          InputProps={{
                            disableUnderline: true,
                          }}
                          fullWidth
                        />
                      </TableCell>
                      <TableCell sx={{ borderBottom: "0px" }}>
                        <TextField
                          sx={{
                            "& .MuiInputBase-root": {
                              color: errtext?.title ? "#912018" : "#111927",
                            },
                            backgroundColor: errtext?.title
                              ? "#FEE4E2"
                              : " #F9FAFB",
                          }}
                          name="price"
                          placeholder=""
                          value={item.total_price}
                          // onChange={(e) => updateInvoiceItem(index, "price", e.target.value)}
                          inputProps={{ maxLength: 50 }}
                          InputProps={{
                            disableUnderline: true,
                          }}
                          disabled
                          fullWidth
                        />
                      </TableCell>
                      <TableCell sx={{ borderBottom: "0px" }}>
                        <IconButton
                          disabled={index === 0}
                          onClick={() => removeInvoiceItem(index)}
                        >
                          <DeleteIcon />
                        </IconButton>
                      </TableCell>
                    </TableRow>
                    <TableRow sx={{ mb: "-20px" }}>
                      <TableCell colSpan={5} sx={{ borderBottom: "0px" }}>
                        <TextField
                          sx={{
                            "& .MuiInputBase-root": {
                              color: errtext?.title ? "#912018" : "#111927",
                            },
                            backgroundColor: errtext?.title
                              ? "#FEE4E2"
                              : " #F9FAFB",
                          }}
                          name="description"
                          value={item.description}
                          placeholder="Description"
                          onChange={(e) =>
                            updateInvoiceItem(
                              index,
                              "description",
                              e.target.value
                            )
                          }
                          inputProps={{ maxLength: 200 }} // allow more text if needed
                          InputProps={{
                            disableUnderline: true,
                          }}
                          fullWidth
                          multiline
                          rows={2}
                        />
                      </TableCell>
                    </TableRow>
                  </>
                ))}
              </TableBody>
            </Table>
            <ErrorTypography textAlign="center">{invoiceError}</ErrorTypography>
            <Box
              sx={{
                display: "flex",
                justifyContent: "flex-end",
                alignItems: "center",
                padding: "16px",
              }}
            >
              <Button
                variant="outlined"
                sx={{ color: "#0E5E84", backgroundColor: "#FFFFFF" }}
                startIcon={<AddIcon />}
                onClick={addInvoiceItem}
              >
                Add
              </Button>
            </Box>
          </TableContainer>
        </Box>

        <Box
          mt={3}
          component="div"
          boxShadow="0 0 3px 0 rgba(0 ,0 ,0 ,0.1)"
          sx={{ borderRadius: "8px" }}
        >
          <Stack
            direction="row"
            alignItems="center"
            gap="10px"
            px="16px"
            sx={{
              height: "66px",
              backgroundColor: "#FCFCFD",
              border: "1px solid #E5E7EB",
              borderRadius: "8px 8px 0px 0px",
            }}
          >
            <ContactDetailsIcon />
            <SecondaryTypography>Payment Details</SecondaryTypography>
          </Stack>
          <Box
            sx={{
              backgroundColor: "#FFF",
              display: "flex",
              flexDirection: "column",
              gap: 1,
              p: 2,
            }}
          >
            <SecondaryTypography>
              Handling Charges (Optional)
            </SecondaryTypography>
            <TextField
              sx={{
                "& .MuiInputBase-root": {
                  color: errtext?.title ? "#912018" : "#111927",
                },
                backgroundColor: errtext?.title ? "#FEE4E2" : " #F9FAFB",
                width: "40%",
              }}
              type="number"
              name="handling_charge"
              placeholder="Handling Charges"
              value={handlingCharge}
              onChange={(e) => {
                const value = e.target.value;
                if (/^\d*$/.test(value)) {
                  // ✅ allow only digits
                  setHandlingCharge(value);
                }
              }}
              inputProps={{
                maxLength: 50,
                inputMode: "numeric",
                pattern: "[0-9]*",
              }}
              InputProps={{
                disableUnderline: true,
              }}
              fullWidth
              onKeyDown={(e) => {
                if (e.key === "ArrowUp" || e.key === "ArrowDown") {
                  e.preventDefault();
                }
              }}
              onWheel={(e) => e.target.blur()}
            />
          </Box>

          <Box
            sx={{
              backgroundColor: "#FFF",
              p: 2,
              borderRadius: "0px 0px 8px 8px",
            }}
          >
            {[
              { label: "Subtotal", value: `S$ ${subTotal}` },
              { label: "Handling Amount", value: `S$ ${handlingCharge || 0}` },
              { label: "GST (9% Excl.)", value: `S$ ${gstAmount}` },
              { label: "Total Amount", value: `S$ ${total}` },
            ].map((item, index) => (
              <Box
                key={index}
                sx={{
                  display: "grid",
                  gridTemplateColumns: "200px auto", // left col fixed, right col auto
                  alignItems: "center",
                  mb: index !== 3 ? 1 : 0,
                }}
              >
                <Typography
                  sx={{ fontSize: "14px", fontWeight: 400, color: "#6C737F" }}
                >
                  {item.label}
                </Typography>
                <Typography
                  sx={{ fontSize: "14px", fontWeight: 400, color: "#111927" }}
                >
                  {item.value}
                </Typography>
              </Box>
            ))}
          </Box>
        </Box>

        <Box
          mt={3}
          component="div"
          boxShadow="0 0 3px 0 rgba(0 ,0 ,0 ,0.1)"
          sx={{ borderRadius: "8px" }}
        >
          <Stack
            direction="row"
            alignItems="center"
            gap="10px"
            px="16px"
            sx={{
              height: "66px",
              backgroundColor: "#FCFCFD",
              border: "1px solid #E5E7EB",
              borderRadius: "8px 8px 0px 0px",
            }}
            justifyContent="space-between"
          >
            <SecondaryTypography>Mark as Recurring</SecondaryTypography>
            <Box sx={{ display: "flex", alignItems: "center", gap: 2 }}>
              <StyledSwitch
                checked={recurring}
                onChange={(e) => {
                  setRecurring(e.target.checked);
                }}
              />
              <Button
                disabled={!recurring}
                onClick={() => setOpen(true)}
                variant="contained"
              >
                Recurrence
              </Button>
            </Box>
          </Stack>
          <Box
            sx={{
              backgroundColor: "#FFF",
              display: "flex",
              flexDirection: "column",
              gap: 1,
              p: 2,
              borderRadius: "0px 0px 8px 8px",
            }}
          >
            <Typography
              sx={{ fontSize: "14px", fontWeight: 400, color: "#111927" }}
            >
              Your monthly service charges will be auto-generated every month.
              Stay notified and pay easily from the app.
            </Typography>
          </Box>
        </Box>

        <Box
          mt={2}
          bgcolor="#FFFFFF"
          sx={{
            border: "1px solid  #E5E7EB",
            borderTop: " 1px solid #F3F4F6",
            boxShadow: "0 0 3px 0 rgba(0 ,0 ,0 ,0.1)",
            borderRadius: "0px 0px 8px 8px",
          }}
        >
          <Stack
            direction="row"
            py={2}
            px={2}
            justifyContent="end"
            alignItems="center"
            height="60px"
          >
            <Stack direction="column" justifyContent="end" alignItems="end">
              <Button
                type="button"
                onClick={() => {
                  if (validateInvoiceItems()) {
                    Continue(
                      "Review & Send",
                      "Invoice Items & Payment Details"
                    );
                  }
                }}
                variant="Standard"
              >
                Continue
              </Button>
            </Stack>
          </Stack>
        </Box>
      </>
    );
  };
  const ReviewInformation = () => {
    return (
      <>
        <Box
          mt={3}
          component="div"
          boxShadow="0 0 3px 0 rgba(0 ,0 ,0 ,0.1)"
          borderRadius="8px 8px 0 0"
          width="100%"
        >
          <Box
            sx={{
              borderBottom: "1px solid #E5E7EB",
              backgroundColor: "#FFFFFF",
              borderRadius: "8px 8px 0 0 ",
            }}
          >
            <Tabs
              sx={{ width: "100%" }}
              value={tabValue}
              onChange={handleTabValue}
            >
              <Tab sx={{ width: "50%", maxWidth: "none" }} label={"Details"} />
              <Tab sx={{ width: "50%", maxWidth: "none" }} label={"Preview"} />
            </Tabs>
          </Box>

          <CustomTabPanel value={tabValue} index={0}>
            <Stack
              direction="row"
              alignItems="center"
              gap="10px"
              px="16px"
              sx={{
                height: "66px",
                backgroundColor: "#FCFCFD",
                borderBottom: "1px solid #E5E7EB",
              }}
            >
              <SecondaryTypography>Invoice Details</SecondaryTypography>
            </Stack>
            <Grid
              container
              xs={12}
              gap="2.8%"
              sx={{ backgroundColor: "white", padding: "30px 16px 30px 16px" }}
            >
              <Grid xs={12} sm={5.8} my={2}>
                <StyledSecondaryTypography>
                  Invoice Type
                </StyledSecondaryTypography>
                <TypographyDefault mt={0.5}>
                  {PersonalDetailsData?.recipients_type !== ""
                    ? PersonalDetailsData?.recipients_type == 1
                      ? "Single Resident"
                      : "Multiple Residents"
                    : ""}
                </TypographyDefault>
              </Grid>

              {PersonalDetailsData?.recipients_type === 2 && (
                <Grid xs={12} sm={5.8} my={2}>
                  <StyledSecondaryTypography>
                    Group Name
                  </StyledSecondaryTypography>
                  <TypographyDefault mt={0.5}>
                    {selectedGroup?.title || ""}
                  </TypographyDefault>
                </Grid>
              )}

              {PersonalDetailsData?.recipients_type === 1 && (
                <>
                  <Grid xs={12} sm={5.8} my={2}>
                    <StyledSecondaryTypography>
                      Resident
                    </StyledSecondaryTypography>
                    <TypographyDefault mt={0.5}>
                      {selectedResident?.user_details?.name || ""}
                    </TypographyDefault>
                  </Grid>

                  {/* <Grid xs={12} sm={5.8} my={2}>
                <StyledSecondaryTypography>Building</StyledSecondaryTypography>
                <TypographyDefault mt={0.5}>{selectedbuilding?.building_name || ""}</TypographyDefault>
              </Grid>
              <Grid xs={12} sm={5.8} my={2}>
                <StyledSecondaryTypography>Level</StyledSecondaryTypography>
                <TypographyDefault mt={0.5}>{selectedbuilding?.level?.filter((data) => data?.id === WorkAccessData?.level)?.[0]?.level || ""}</TypographyDefault>
              </Grid>
              <Grid xs={12} sm={5.8} my={2}>
                <StyledSecondaryTypography>Unit</StyledSecondaryTypography>
                <TypographyDefault mt={0.5}>{selectedbuilding?.level?.filter((data) => data?.id === WorkAccessData?.level)?.[0]?.building_unit?.filter((unit) => unit?.id === WorkAccessData?.unit)?.[0]?.unit_no || ""}</TypographyDefault>
              </Grid> */}
                </>
              )}

              <Grid xs={12} sm={5.8} my={2}>
                <StyledSecondaryTypography>
                  Invoice Date
                </StyledSecondaryTypography>
                <TypographyDefault mt={0.5}>
                  {PersonalDetailsData?.invoice_date
                    ? dayjs(PersonalDetailsData?.invoice_date).format(
                        "DD MMM YYYY"
                      )
                    : ""}
                </TypographyDefault>
              </Grid>
              <Grid xs={12} sm={5.8} my={2}>
                <StyledSecondaryTypography>Due Date</StyledSecondaryTypography>
                <TypographyDefault mt={0.5}>
                  {PersonalDetailsData?.due_date
                    ? dayjs(PersonalDetailsData?.due_date).format("DD MMM YYYY")
                    : ""}
                </TypographyDefault>
              </Grid>
            </Grid>

            {/* Announcement Type  */}

            <Stack
              direction="row"
              alignItems="center"
              gap="10px"
              px="16px"
              sx={{
                height: "66px",
                backgroundColor: "#FCFCFD",
                borderBottom: "1px solid #E5E7EB",
                borderTop: "1px solid #E5E7EB",
              }}
            >
              <SecondaryTypography>Invoice Items</SecondaryTypography>
            </Stack>
            <TableContainer sx={{ backgroundColor: "#FFF" }}>
              <Table>
                <TableHead>
                  <TableRow>
                    <TableCell sx={{ padding: "8px" }}>
                      <StyledSecondaryTypography>
                        Item Name
                      </StyledSecondaryTypography>
                    </TableCell>
                    <TableCell sx={{ padding: "8px" }}>
                      <StyledSecondaryTypography>
                        Unit{" "}
                      </StyledSecondaryTypography>
                    </TableCell>
                    <TableCell sx={{ padding: "8px" }}>
                      <StyledSecondaryTypography>Qty</StyledSecondaryTypography>
                    </TableCell>
                    <TableCell sx={{ padding: "8px" }}>
                      {" "}
                      <StyledSecondaryTypography>
                        Item Price
                      </StyledSecondaryTypography>{" "}
                    </TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {invoiceItems.map((item, index) => (
                    <TableRow key={index}>
                      <TableCell sx={{ borderBottom: "0px" }}>
                        <TypographyDefault mt={0.5}>
                          {item?.item_name}
                        </TypographyDefault>
                      </TableCell>
                      <TableCell sx={{ borderBottom: "0px" }}>
                        <TypographyDefault mt={0.5}>
                          {item?.unit_name}
                        </TypographyDefault>
                      </TableCell>
                      <TableCell sx={{ borderBottom: "0px" }}>
                        <TypographyDefault mt={0.5}>
                          {item?.quantity}
                        </TypographyDefault>
                      </TableCell>
                      <TableCell sx={{ borderBottom: "0px" }}>
                        <TypographyDefault mt={0.5}>
                          S$ {item?.price}
                        </TypographyDefault>
                      </TableCell>
                    </TableRow>
                  ))}
                </TableBody>
              </Table>
            </TableContainer>

            {/* Announcement Details  */}

            <Stack
              direction="row"
              alignItems="center"
              gap="10px"
              px="16px"
              sx={{
                height: "66px",
                backgroundColor: "#FCFCFD",
                borderBottom: "1px solid #E5E7EB",
                borderTop: "1px solid #E5E7EB",
              }}
            >
              <SecondaryTypography>Payment Details</SecondaryTypography>
            </Stack>
            <Box
              sx={{
                backgroundColor: "#FFF",
                p: 2,
              }}
            >
              {[
                { label: "Subtotal", value: `S$ ${subTotal}` },
                {
                  label: "Handling Amount",
                  value: `S$ ${handlingCharge || 0}`,
                },
                { label: "GST (9% Excl.)", value: `S$ ${gstAmount}` },
                { label: "Total Amount", value: `S$ ${total}` },
              ].map((item, index) => (
                <Box
                  key={index}
                  sx={{
                    display: "grid",
                    gridTemplateColumns: "200px auto", // left col fixed, right col auto
                    alignItems: "center",
                    mb: index !== 3 ? 1 : 0,
                  }}
                >
                  <StyledSecondaryTypography
                    sx={{ fontSize: "14px", fontWeight: 400, color: "#6C737F" }}
                  >
                    {item.label}
                  </StyledSecondaryTypography>
                  <TypographyDefault
                    sx={{ fontSize: "14px", fontWeight: 400, color: "#111927" }}
                  >
                    {item.value}
                  </TypographyDefault>
                </Box>
              ))}
            </Box>

            {/* IMages */}

            <Stack
              direction="row"
              alignItems="center"
              gap="10px"
              px="16px"
              sx={{
                height: "66px",
                backgroundColor: "#FCFCFD",
                borderBottom: "1px solid #E5E7EB",
                borderTop: "1px solid #E5E7EB",
              }}
            >
              <SecondaryTypography>Terms & Conditions</SecondaryTypography>
            </Stack>
            <Box
              sx={{
                backgroundColor: "#FFF",
                display: "flex",
                flexDirection: "column",
                gap: 1,
                p: 2,
              }}
            >
              <Typography
                sx={{ fontSize: "14px", fontWeight: 400, color: "#111927" }}
              >
                Payment is due by the stated due date. Late payments may incur
                admin fees. All items are non-refundable once delivered or
                installed.
              </Typography>
            </Box>
            <Stack
              direction="row"
              alignItems="center"
              gap="10px"
              px="16px"
              sx={{
                height: "66px",
                backgroundColor: "#FCFCFD",
                borderBottom: "1px solid #E5E7EB",
                borderTop: "1px solid #E5E7EB",
              }}
            >
              <SecondaryTypography>Mark as Recurring</SecondaryTypography>
            </Stack>
            <Box
              sx={{
                backgroundColor: "#FFF",
                display: "flex",
                flexDirection: "column",
                gap: 1,
                p: 2,
                borderRadius: "0px 0px 8px 8px",
              }}
            >
              <Typography
                sx={{ fontSize: "14px", fontWeight: 400, color: "#111927" }}
              >
                Your monthly service charges will be auto-generated every month.
                Stay notified and pay easily from the app.
              </Typography>
            </Box>
          </CustomTabPanel>

          <CustomTabPanel value={tabValue} index={1}>
            <Stack
              py={1}
              direction="column"
              alignItems="center"
              justifyContent="center"
              px="16px"
              sx={{
                height: "66px",
                backgroundColor: "#F9FAFB",
                borderBottom: "1px solid #E5E7EB",
                borderTop: "1px solid #E5E7EB",
              }}
            >
              <StyledPrimaryDefaultTypography>
                {LanguageData?.Mobile_Preview || "Mobile App Preview"}{" "}
              </StyledPrimaryDefaultTypography>
              <StyledSecondaryTypography>
                {LanguageData?.Scroll_mobile ||
                  "Scroll on the mobile phone to review details"}
              </StyledSecondaryTypography>
            </Stack>
            <Box
              width="100%"
              display="flex"
              alignItems="center"
              justifyContent="center"
            >
              <Box
                my={6.5}
                sx={{
                  width: "375px",
                  height: "750px",
                  backgroundColor: "#FFFFFF",
                  borderRadius: "8px",
                  overflowY: "scroll",
                  "::-webkit-scrollbar": { display: "none" },
                }}
              >
                <Stack sx={{ padding: "24px 16px" }}>
                  <BackArrowMobileIcon />
                  <Box sx={{ display: "flex", gap: 2, mt: 3 }}>
                    <Typography
                      sx={{
                        fontSize: "14px !important",
                        fontWeight: 500,
                        color: "#6C737F",
                      }}
                    >
                      Invoice No • INV-0001
                    </Typography>
                    {getChip("pending")}
                  </Box>
                </Stack>
                <Stack sx={{ padding: "24px 16px" }}>
                  <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
                    <Typography
                      sx={{
                        fontSize: "16px !important",
                        fontWeight: 600,
                        color: "#111927",
                      }}
                    >
                      Due Date:
                    </Typography>
                    <Typography
                      sx={{
                        fontSize: "16px !important",
                        fontWeight: 400,
                        color: "#111927",
                      }}
                    >
                      {PersonalDetailsData?.due_date
                        ? dayjs(PersonalDetailsData?.due_date).format(
                            "DD MMM YYYY"
                          )
                        : ""}
                    </Typography>
                  </Box>
                  <Typography
                    sx={{
                      fontSize: "16px !important",
                      fontWeight: 400,
                      color: "#6C737F",
                    }}
                  >
                    S$ {total}
                  </Typography>
                </Stack>
                <Stack sx={{ padding: "24px 16px" }}>
                  <Stack gap="4px">
                    <SecondaryTypography>Invoice Items</SecondaryTypography>
                    {invoiceItems.map((item, index) => (
                      <Box
                        sx={{
                          display: "flex",
                          justifyContent: "space-between",
                          alignItems: "center",
                          mt: 2,
                        }}
                      >
                        <Box
                          sx={{
                            display: "flex",
                            flexDirection: "column",
                            gap: 1,
                          }}
                        >
                          <Typography
                            sx={{
                              fontSize: "14px",
                              fontWeight: 400,
                              color: "#111927",
                            }}
                          >
                            {item?.item_name}
                          </Typography>
                          <Typography
                            sx={{
                              fontSize: "12px",
                              fontWeight: 400,
                              color: "#6C737F",
                            }}
                          >
                            Qty : {item?.quantity}
                          </Typography>
                        </Box>

                        <Typography
                          sx={{
                            fontSize: "14px",
                            fontWeight: 400,
                            color: "#111927",
                          }}
                        >
                          S$ {item?.price ? item?.price : 0}
                        </Typography>
                      </Box>
                    ))}
                  </Stack>
                </Stack>
                <Stack sx={{ padding: "24px 16px" }}>
                  <Stack gap="4px">
                    <SecondaryTypography>
                      Terms & Conditions
                    </SecondaryTypography>
                    <Typography
                      sx={{
                        fontSize: "14px",
                        fontWeight: 400,
                        color: "#111927",
                      }}
                    >
                      Payment is due by the due date. Late payments may incur
                      admin fees. Items are non-refundable once delivered or
                      installed.
                    </Typography>
                  </Stack>
                </Stack>
                <Stack sx={{ padding: "24px 16px" }}>
                  <Stack gap="4px">
                    <SecondaryTypography>Payment Summary</SecondaryTypography>
                    <Box
                      sx={{
                        display: "flex",
                        justifyContent: "space-between",
                        alignItems: "center",
                        mt: 2,
                      }}
                    >
                      <Typography
                        sx={{
                          fontSize: "14px",
                          fontWeight: 400,
                          color: "#6C737F",
                        }}
                      >
                        Sub Total
                      </Typography>
                      <Typography
                        sx={{
                          fontSize: "14px",
                          fontWeight: 400,
                          color: "#111927",
                        }}
                      >
                        S$ {subTotal}
                      </Typography>
                    </Box>
                    <Box
                      sx={{
                        display: "flex",
                        justifyContent: "space-between",
                        alignItems: "center",
                        mt: 2,
                      }}
                    >
                      <Typography
                        sx={{
                          fontSize: "14px",
                          fontWeight: 400,
                          color: "#6C737F",
                        }}
                      >
                        Handling Charges
                      </Typography>
                      <Typography
                        sx={{
                          fontSize: "14px",
                          fontWeight: 400,
                          color: "#111927",
                        }}
                      >
                        S$ {handlingCharge || 0}
                      </Typography>
                    </Box>
                    <Box
                      sx={{
                        display: "flex",
                        justifyContent: "space-between",
                        alignItems: "center",
                        mt: 2,
                      }}
                    >
                      <Typography
                        sx={{
                          fontSize: "14px",
                          fontWeight: 400,
                          color: "#6C737F",
                        }}
                      >
                        GST (9% Excl.)
                      </Typography>
                      <Typography
                        sx={{
                          fontSize: "14px",
                          fontWeight: 400,
                          color: "#111927",
                        }}
                      >
                        S$ {gstAmount}
                      </Typography>
                    </Box>
                    <Box
                      sx={{
                        display: "flex",
                        justifyContent: "space-between",
                        alignItems: "center",
                        mt: 2,
                      }}
                    >
                      <Typography
                        sx={{
                          fontSize: "14px",
                          fontWeight: 400,
                          color: "#111927",
                        }}
                      >
                        Total Amount
                      </Typography>
                      <Typography
                        sx={{
                          fontSize: "14px",
                          fontWeight: 600,
                          color: "#111927",
                        }}
                      >
                        S$ {total}
                      </Typography>
                    </Box>
                  </Stack>
                </Stack>
                <Box sx={{ mt: 2, mb: 2, padding: "24px 16px" }}>
                  <Button variant="contained" fullWidth>
                    Pay Now
                  </Button>
                </Box>
              </Box>
            </Box>
          </CustomTabPanel>
        </Box>

        <Box
          bgcolor="#FFFFFF"
          sx={{
            borderTop: " 1px solid #F3F4F6",
            boxShadow: "0 0 3px 0 rgba(0 ,0 ,0 ,0.1)",
            borderRadius: "0px 0px 8px 8px",
          }}
          mt={2}
        >
          <Stack
            direction="row"
            py={2}
            px={2}
            justifyContent="end"
            alignItems="center"
            height="60px"
          >
            <Stack direction="column" justifyContent="end" alignItems="end">
              <Button
                onClick={() => {
                  addInvoice();
                  // handleCreateAnnouncement();
                  //   SetPostLoader(true);
                }}
                variant="Standard"
              >
                {LanguageData?.Common_CreateNow || "Create Now"}
              </Button>
            </Stack>
          </Stack>
        </Box>
      </>
    );
  };

  const deleteContactDetail = () => {
    navigate("/invoice-list");
  };
  const handleShowDeleteModal = () => {
    setshowDeleteModal(!showDeleteModal);
  };

  const style = {
    position: "absolute",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    width: 420,
    bgcolor: "background.paper",
    borderRadius: "12px",
    boxShadow: 24,
    p: 4,
  };

  return (
    <>
      {postLoader && <PostLoaderModal />}
      {showDeleteModal && (
        <AlertModal
          modalDatas={deleteModalDatas}
          confirmFunction={deleteContactDetail}
          closeFunction={handleShowDeleteModal}
        />
      )}
      {open && (
        <Modal open={open} onClose={() => setOpen(false)}>
          <Box sx={style}>
            <Typography variant="h6" component="h2">
              Custom Recurrence
            </Typography>
            <Box sx={{ display: "flex", alignItems: "center", gap: 1, mt: 2 }}>
              <Box sx={{ width: "30%" }}>
                <StyledPrimaryDefaultTypography>
                  Repeat every
                </StyledPrimaryDefaultTypography>
              </Box>
              <Box sx={{ width: "20%" }}>
                <TextField
                  name="repeat_every"
                  type="number"
                  value={repeatEvery}
                  disabled
                  sx={{
                    "& .MuiInputBase-root": {
                      color: errtext?.title ? "#912018" : "#111927",
                    },
                    backgroundColor: errtext?.title ? "#FEE4E2" : " #F9FAFB",
                  }}
                  InputProps={{ disableUnderline: true }}
                />
              </Box>
              <Box
                sx={{ display: "flex", flexDirection: "column", width: "10%" }}
              >
                <IconButton
                  sx={{ height: "20px" }}
                  onClick={() => increaseRepeatEvery()}
                >
                  <ArrowDropUpIcon />
                </IconButton>
                <IconButton
                  sx={{ height: "20px" }}
                  onClick={() => decreaseRepeatEvery()}
                >
                  <ArrowDropDownIcon />
                </IconButton>
              </Box>
              <Box sx={{ width: "40%" }}>
                <Select
                  labelId="period-label"
                  value={period}
                  onChange={handlePeriodChange}
                  sx={{ minWidth: 120 }}
                >
                  {options.map((opt, index) => (
                    <MenuItem key={index} value={opt.replace(/s$/, "")}>
                      {opt}
                    </MenuItem>
                  ))}
                </Select>
              </Box>
            </Box>

            <Box>
              {period === "month" && (
                <>
                  <Box sx={{ mt: 2, display: "flex" }}>
                    {/* Select option: by date OR by weekday occurrence */}
                    <FormControl sx={{ mr: 2, width: "42%" }}>
                      <InputLabel id="month-option-label">Option</InputLabel>
                      <Select
                        labelId="month-option-label"
                        value={monthOption}
                        onChange={(e) => setMonthOption(e.target.value)}
                      >
                        <MenuItem value="date">Day of Month</MenuItem>
                        <MenuItem value="weekday">Weekday</MenuItem>
                      </Select>
                    </FormControl>

                    {monthOption === "date" && (
                      <FormControl sx={{ minWidth: 100 }}>
                        <InputLabel id="day-label">Day</InputLabel>
                        <Select
                          labelId="day-label"
                          value={dayOfMonth}
                          onChange={(e) => setDayOfMonth(e.target.value)}
                        >
                          {Array.from({ length: 31 }, (_, i) => i + 1).map(
                            (day) => (
                              <MenuItem key={day} value={day}>
                                {day}
                              </MenuItem>
                            )
                          )}
                        </Select>
                      </FormControl>
                    )}

                    {monthOption === "weekday" && (
                      <Box sx={{ display: "flex", gap: 2 }}>
                        <FormControl sx={{ minWidth: 120 }}>
                          <InputLabel id="week-label">Week</InputLabel>
                          <Select
                            labelId="week-label"
                            value={weekNumber}
                            onChange={(e) => setWeekNumber(e.target.value)}
                          >
                            {weekNumbers.map((label, idx) => (
                              <MenuItem key={idx} value={idx + 1}>
                                {label}
                              </MenuItem>
                            ))}
                          </Select>
                        </FormControl>

                        <FormControl sx={{ minWidth: 120 }}>
                          <InputLabel id="weekday-label">Day</InputLabel>
                          <Select
                            labelId="weekday-label"
                            value={weekday}
                            onChange={(e) => setWeekday(e.target.value)}
                          >
                            {weekdays.map((day, idx) => (
                              <MenuItem key={idx} value={idx}>
                                {day}
                              </MenuItem>
                            ))}
                          </Select>
                        </FormControl>
                      </Box>
                    )}
                  </Box>
                </>
              )}

              {period === "week" && (
                <ToggleButtonGroup
                  value={selectedDays}
                  onChange={handleChange}
                  aria-label="week occurrence"
                  sx={{ display: "flex", gap: 1.5, mt: 2, mb: 2 }}
                >
                  {days.map((day, index) => (
                    <ToggleButton
                      key={index}
                      value={index}
                      aria-label={day}
                      sx={{
                        borderRadius: "100%",
                        width: 40,
                        height: 40,
                        textTransform: "none",
                        "&.Mui-selected": {
                          backgroundColor: "#0e5e84",
                          color: "#fff",
                          "&:hover": { backgroundColor: "#0e5e84" },
                        },
                      }}
                    >
                      {day[0]}
                    </ToggleButton>
                  ))}
                </ToggleButtonGroup>
              )}

              {period === "year" && (
                <Box sx={{ mt: 2, display: "flex", gap: 2 }}>
                  {/* Select Month */}
                  <FormControl sx={{ minWidth: 120 }}>
                    <InputLabel id="year-month-label">Month</InputLabel>
                    <Select
                      labelId="year-month-label"
                      value={yearMonth}
                      onChange={(e) => setYearMonth(e.target.value)}
                    >
                      {[
                        "January",
                        "February",
                        "March",
                        "April",
                        "May",
                        "June",
                        "July",
                        "August",
                        "September",
                        "October",
                        "November",
                        "December",
                      ].map((month, idx) => (
                        <MenuItem key={idx} value={idx + 1}>
                          {month}
                        </MenuItem>
                      ))}
                    </Select>
                  </FormControl>

                  {/* Select Day */}
                  <FormControl sx={{ minWidth: 120 }}>
                    <InputLabel id="year-day-label">Day</InputLabel>
                    <Select
                      labelId="year-day-label"
                      value={yearDay}
                      onChange={(e) => setYearDay(e.target.value)}
                    >
                      {Array.from({ length: 31 }, (_, i) => i + 1).map(
                        (day) => (
                          <MenuItem key={day} value={day}>
                            {day}
                          </MenuItem>
                        )
                      )}
                    </Select>
                  </FormControl>
                </Box>
              )}
            </Box>

            <Box>
              <StyledPrimaryDefaultTypography sx={{ mt: 2, mb: 1 }}>
                Ends
              </StyledPrimaryDefaultTypography>
              <RadioGroup
                value={endType}
                onChange={(e) => setEndType(e.target.value)}
              >
                {/* Never */}
                <Box>
                  <FormControlLabel
                    control={<Radio />}
                    label="Never"
                    value="never"
                  />
                </Box>

                {/* On Date */}
                <Box sx={{ display: "flex", alignItems: "center", gap: 2 }}>
                  <FormControlLabel
                    control={<Radio />}
                    label="On"
                    value="on_date"
                    sx={{ width: "50%" }}
                  />

                  <LocalizationProvider dateAdapter={AdapterDayjs}>
                    <DatePicker
                      value={endDate}
                      onChange={(newValue) => setEndDate(newValue)}
                      disabled={endType !== "on_date"} // only enabled when selected
                      slotProps={{
                        textField: {
                          sx: {
                            "& .MuiInputBase-root": {
                              color: errtext?.title ? "#912018" : "#111927",
                            },
                            backgroundColor: errtext?.title
                              ? "#FEE4E2"
                              : "#F9FAFB",
                          },
                          variant: "standard",
                          InputProps: { disableUnderline: true },
                          error: !!errtext?.title,
                          helperText: errtext?.title || "",
                        },
                      }}
                    />
                  </LocalizationProvider>
                </Box>

                {/* After Occurrences */}
                <Box sx={{ display: "flex", alignItems: "center", gap: 2 }}>
                  <FormControlLabel
                    control={<Radio />}
                    label="After"
                    value="after"
                    sx={{ width: "50%" }}
                  />

                  <TextField
                    type="number"
                    value={afterOccurrences}
                    onChange={(e) => setAfterOccurrences(e.target.value)}
                    placeholder="Occurrences"
                    disabled={endType !== "after"} // only enabled when selected
                    sx={{
                      "& .MuiInputBase-root": {
                        color: errtext?.title ? "#912018" : "#111927",
                      },
                      backgroundColor: errtext?.title ? "#FEE4E2" : "#F9FAFB",
                    }}
                    InputProps={{ disableUnderline: true }}
                  />
                </Box>
              </RadioGroup>
            </Box>
            <Box
              sx={{
                display: "flex",
                justifyContent: "flex-end",
                flexDirection: "row",
                gap: 2,
                mt: 2,
              }}
            >
              <Button
                variant="outlined"
                sx={{ mt: 2 }}
                onClick={() => {
                  setOpen(false);
                }}
              >
                Cancel
              </Button>
              <Button
                variant="contained"
                sx={{ mt: 2 }}
                onClick={() => {
                  setOpen(false);
                }}
              >
                Done
              </Button>
            </Box>
          </Box>
        </Modal>
      )}

      <Box p={5} sx={{ backgroundColor: "#F3F4F6" }}>
        <Stack mb={3} direction="row" justifyContent="space-between">
          <BackArrow
            onClick={() => navigate("/invoice-list")}
            style={{ marginBottom: "16px", cursor: "pointer" }}
          />
          {/* <BorderAlertCloseIcon
            width="40"
            height="40"
            cursor="pointer"
            onClick={() => setshowDeleteModal(true)}
          /> */}
        </Stack>
        <Box mb={5}>
          <PrimaryTypography mb={1}>Create Invoice</PrimaryTypography>
          <StyledSecondaryTypography>
            Create and send invoices to residents for selected services or
            products. Add details, apply charges, and push to the resident app
            for payment and tracking.
          </StyledSecondaryTypography>
        </Box>
        <Grid container gap="1.5%">
          {blocks.map((itm) => {
            return (
              <Grid
                xs={3.87}
                onClick={() => Continue(itm.tle, "")}
                sx={{ "&:hover": { cursor: "pointer" } }}
              >
                <Box
                  component="div"
                  sx={{
                    borderTop: itm.status
                      ? "3px solid #0E4965"
                      : "3px solid #D2D6DB",
                    width: "100%",
                    color: itm.status ? "#0E4965" : "#9DA4AE",
                  }}
                >
                  <Typography
                    sx={{
                      fontWeight: "500",
                      fontSize: "12px",
                      padding: "10px 0 0 0",
                    }}
                  >
                    {itm.tle}
                  </Typography>
                </Box>
              </Grid>
            );
          })}
        </Grid>
        {addblocks.Personal_Details && PersonalDetails()}
        {addblocks.WorkAccess_Details && WorkAccessDetails()}
        {addblocks.Review_Information && ReviewInformation()}
      </Box>
    </>
  );
};

export default CreateInvoice;
